import React, {PureComponent, ReactNode} from "react"
import gql from "graphql-tag"
import {Query} from "react-apollo"
import {ApolloQueryResult} from "apollo-client"

import {RewardOrder} from "@irati/types"
import {Query as QueryComponent} from "@irati/utils/services/apollo"
import partialUser from "@irati/identity/services/fragments/PartialUser"

export const query = gql`
  query RewardOrders(
  $tenantId: String,
  $limit: Int,
  $offset: Int,
  $author: String,
  $status: String,
  $partialRewardOrders: Boolean = false) {
    rewardOrders(tenantId: $tenantId, limit: $limit, offset: $offset, author: $author, status: $status) {
      count
      limit
      offset
      total
      results {
        uuid
        custom @skip(if: $partialRewardOrders)
        createdAt
        createdBy {
          ...partialUser
        }
        recipients {
          results {
            ...partialUser
          }
        }
        reward {
          uuid @skip(if: $partialRewardOrders)
          header
          redemptionInstructions @skip(if: $partialRewardOrders)
          importantInfo @skip(if: $partialRewardOrders)
          deliveryInfo @skip(if: $partialRewardOrders)
          isCredit @skip(if: $partialRewardOrders)
        }
        quantity
        costTotal {
          amount
          currency @skip(if: $partialRewardOrders)
        }
        costPerUnit {
          amount
          currency @skip(if: $partialRewardOrders)
        }
        updatedAt

        status @skip(if: $partialRewardOrders)

        paymentOrder @skip(if: $partialRewardOrders) {
          uuid
          status
        }

        poll @skip(if: $partialRewardOrders) {
          uuid
          createdAt
          endsAt
          title
          desc
          createdBy {
            ...partialUser
          }
        }

        recognition @skip(if: $partialRewardOrders) {
          uuid
          createdAt
          message
          moderated
          createdBy {
            ...partialUser
          }
        }
      }
    }
  }
  ${partialUser}
`

const variables = {
  limit: 20,
  offset: 0
}

const defaultProps = {
  query,
  variables
}

interface Variables {
  author?: string,
  limit: number,
  offset: number,
  status?: string,
  tenantId: string,
  partialRewardOrders?: boolean
}

interface Props {
  query?: string,
  variables?: Variables,
  children?: ReactNode
}

interface Data {
  rewardOrders: {
    count: number,
    limit: number,
    offset: number,
    total: number,
    results: RewardOrder[]
  }
}

export type RewardOrdersQueryResult = ApolloQueryResult<Data>

class TypedQuery extends Query<Data, Variables> {}

export default class RewardOrdersQuery extends PureComponent<Props> {
  static defaultProps = defaultProps

  render() {
    return (
      <QueryComponent
        {...this.props}
        Query={TypedQuery}
        fetchPolicy="network-only"
        notifyOnNetworkStatusChange />
    )
  }
}
